import React from 'react';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder';
import { GCPSubnetFieldComponent, GCPSubnetFieldUiOptions } from '../GCPSubnetFieldComponent';

export const GCPSubnetSelectorFieldExtension = (
  props: FieldExtensionComponentProps<string[], GCPSubnetFieldUiOptions>,
) => {
  return <GCPSubnetFieldComponent {...props} />;
};